import { withStyles } from "@mui/styles";
import { Cookies } from "react-cookie";
import { useSelector } from "react-redux";
import { darkTheme, lightTheme } from "Theme";
import { rem } from "assets/js/common";

function Global(theme) {
  let cookies = new Cookies();
  let palette = lightTheme.palette;

  const GlobalCss = withStyles({
    // @global is handled by jss-plugin-global.

    "@global": {
      /**************************************************************************************************
      layout
      **************************************************************************************************/
      ".App-header": {
        position: "fixed",
        width: "100%",
        height: rem(52),
        zIndex: 2,
        backgroundColor: "#fff",
        "&.bg-grey": {
          backgroundColor: "#F6F6F6",
        },
      },
      ".App-body": {
        height: "calc(var(--vh, 1vh) * 100 - 52)",
        paddingTop: rem(52),
      },
      ".App-contents": {
        width: "100%",
        // height: "100%",
        // paddingBottom: rem(60),
      },
      ".App-footer": {
        position: "fixed",
        width: "100%",
        height: rem(80),
        zIndex: 2,
        bottom: "-2px",
        backgroundColor: "#F1270B",
      },
      ".App-footer-ios": {
        position: "fixed",
        width: "100%",
        height: rem(65),
        zIndex: 2,
        bottom: "-2px",
        backgroundColor: "#F1270B",
      },
      ".container": {
        minHeight: "calc(100vh - 52px)",
        paddingBottom: rem(60),
        display: "flex",
        flexDirection: "column",
      },
      ".scroll-hidden": {
        overflow: "hidden",
      },
      ".nopad": {
        padding: 0,
      },
      ".h-group": {
        marginBottom: rem(30),

        "& h2": {
          fontSize: rem(30),
        },
      },
      ".box-type": {
        "&-1": {
          padding: rem(30),
        },
        "&-2": {
          padding: `${rem(35)} ${rem(30)}`,
        },
        "&-3": {
          padding: `${rem(30)} ${rem(25)}`,
        },
        "&-4": {
          padding: `${rem(30)} ${rem(30)} ${rem(25)} ${rem(30)}`,
        },
        "&-5": {
          padding: `${rem(40)} ${rem(30)}`,
        },
        "&-6": {
          padding: `0 ${rem(30)}`,
        },
        "&-7": {
          padding: `${rem(25)} ${rem(30)}`,
        },
        "&-8": {
          padding: `${rem(10)} ${rem(30)} ${rem(60)} ${rem(30)}`,
        },
        "&-9": {
          padding: `${rem(30)} ${rem(30)} ${rem(60)}`,
        },
        "&-10": {
          padding: `${rem(30)} ${rem(30)} ${rem(40)}`,
        },
        "&-11": {
          padding: `${rem(30)} ${rem(20)}`,
        },
      },

      /**************************************************************************************************
      color
      **************************************************************************************************/
      ".color-black": {
        color: `${palette.common.black} !important`,
      },

      ".color-primary": {
        color: `${palette.primary.main} !important`,
      },

      ".color-secondary": {
        color: `${palette.secondary.main} !important`,
      },

      ".color-info": {
        color: `${palette.info.main} !important`,
      },

      ".color-info-sm": {
        color: `${palette.info.main} !important`,
        fontSize: rem(14),
      },

      ".color-disabled": {
        color: `${palette.text.disabled} !important`,
      },

      /**************************************************************************************************
      font-size
      **************************************************************************************************/
      ".font-14": {
        fontSize: `${rem(14)} !important`,
      },
      ".font-15": {
        fontSize: `${rem(15)} !important`,
      },

      /**************************************************************************************************
      align
      **************************************************************************************************/
      ".align-c": {
        textAlign: "center !important",
      },
      ".align-start": {
        alignItems: "start !important",
      },

      /**************************************************************************************************
      Title
      **************************************************************************************************/
      ".h2": {
        fontSize: rem(16),
      },
      h3: {
        fontSize: rem(18),
        "&.h3": {
          fontSize: rem(24),
          letterSpacing: "-1px",
          lineHeight: "1.3",
        },
      },
      ".weight300": {
        fontWeight: "300 !important",
      },
      ".weight700": {
        fontWeight: "700 !important",
      },
      ".weight800": {
        fontWeight: "800 !important",
      },

      /**************************************************************************************************
      Typography
      **************************************************************************************************/
      ".ellipsis": {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
      },
      ".title-group": {
        "& .ellipsis": {
          display: "inline-block",
          maxWidth: "calc(100vw - 81px)",
          verticalAlign: "middle",
        },
        "& .ico-new": {
          display: "inline-block",
          width: rem(17),
          height: rem(17),
          marginLeft: rem(6),
          backgroundImage: `url(${
            process.env.PUBLIC_URL
          }/images/icon/new.svg)`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          verticalAlign: "middle",
        },
      },
      ".info-txt": {
        fontSize: rem(14),
        color: palette.text.disabled,
      },

      body: {
        color: `${palette.text.primary}`,
        "& svg": {
          color: `${palette.text.primary}`,
        },
        "& a": {
          color: palette.text.primary,
        },

        "& .MuiTouchRipple-root": {
          display: "none",
        },

        /**************************************************************************************************
        Divider
        **************************************************************************************************/
        "& .MuiDivider-root": {
          // borderColor: `${palette.info.light}`,
          borderColor: `${palette.grey[100]}`,
          "&.divider-type-2": {
            height: rem(12),
            border: "none",
            backgroundColor: palette.background.default,
          },
          "&.MuiDivider-middle": {
            marginLeft: rem(30),
            marginRight: rem(30),
          },
          "&.MuiDivider-light": {
            borderColor: `${palette.background.default}`,
          },
        },

        /**************************************************************************************************
        Icon
        **************************************************************************************************/
        "& .MuiIcon-root": {
          position: "relative",
          "& img": {
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%,-50%)",
          },
        },

        /**************************************************************************************************
        Button
        **************************************************************************************************/
        "& [class*='btn-']": {
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        },

        "& .MuiButton-root": {
          boxShadow: "none",
          padding: "0 20px",
          textTransform: "none",

          "&.Mui-disabled": {
            color: palette.common.white,
            "& .MuiSvgIcon-root": {
              color: palette.common.white,
            },
          },
          "&.MuiButton-containedCommon": {
            backgroundColor: palette.common.black,
            color: palette.common.white,
          },
          "& + .MuiButton-root": {
            marginLeft: "8px",
          },
          "& .MuiButton-root:not(.MuiButton-text)": {
            "&.Mui-disabled": {
              backgroundColor: palette.grey[500],
            },
          },
          "& .MuiSvgIcon-root": {
            // marginRight: "5px",
            fontSize: "20px",
          },
          "&:hover": {
            boxShadow: "none",
          },
        },
        "& .MuiButton-sizeSmall": {
          height: rem(32),
          fontSize: rem(14),
        },
        "& .MuiButton-sizeMedium": {
          height: rem(54),
          borderRadius: rem(10),
          fontWeight: 700,
          fontSize: rem(16),
        },
        "& .MuiButton-outlined": {
          "& .MuiSvgIcon-root": {
            color: palette.primary.main,
          },
          "&.MuiButton-outlinedPrimary": {
            "border-color": palette.primary.main,
            background: "transparent",
            "&:focus": {
              background: "transparent",
            },
          },

          "&.MuiButton-outlinedSecondary": {
            "border-color": palette.secondary.main,
          },
        },
        "& .MuiButton-contained": {
          "& .MuiSvgIcon-root": {
            color: palette.common.white,
          },
        },
        "& .btn-rounded": {
          borderRadius: "50px",
          "&.MuiButton-containedSizeLarge": {
            height: rem(62),
            padding: `0 ${rem(45)}`,
            fontSize: rem(18),
          },
          "&.MuiButton-outlinedSizeSmall": {
            height: rem(32),
            padding: `0 ${rem(20)}`,
            fontSize: rem(14),
            "&.end-icon": {
              paddingRight: rem(15),
              "& .ico-go": {
                width: rem(16),
                height: rem(16),
              },
            },
          },
        },
        "& .MuiButton-text": {
          height: "auto",
          padding: 0,
          color: palette.text.primary,
          fontSize: rem(16),
          fontWeight: 700,
          letterSpacing: "-0.5px",
          "&:hover": {
            backgroundColor: "transparent",
          },
          "& .MuiSvgIcon-root": {
            color: palette.text.primary,
          },
          "&.Mui-disabled": {
            color: `${palette.grey[500]} !important`,
            "& .MuiSvgIcon-root": {
              color: `${palette.grey[500]} !important`,
            },
          },
          "&.underline": {
            borderBottom: `1px solid ${palette.text.primary}`,
            lineHeight: 1,
          },
        },
        "& .MuiButton-textInfo": {
          color: palette.info.main,
        },
        "& .MuiIconButton-root": {
          padding: 0,
          "&:hover": {
            backgroundColor: "transparent",
          },
          "& .MuiSvgIcon-root": {
            color: palette.primary.main,
          },
        },
        "& .btn-cancel": {
          backgroundColor: palette.grey[500],
        },
        "& .btn-fixed": {
          width: rem(90),
        },
        "& .btn-link": {
          "&.underline": {
            borderBottom: `1px solid ${palette.text.primary}`,
            lineHeight: 1,
          },
        },
        "& a": {
          display: "inline-flex",
          alignItems: "center",
          "& [class*='ico-']": {
            position: "relative",
            top: rem(-2),
          },
          "&.link-outlined": {
            border: "1px solid #000",
            "&.link-primary": {
              borderColor: palette.primary.main,
            },
          },
          "&.link-size-small": {
            height: rem(32),
            padding: `0 ${rem(20)}`,
            fontSize: rem(14),
          },
          "&.link-primary": {
            color: palette.primary.main,
          },
          "&.end-icon": {
            paddingRight: rem(15),
            "& .ico-go": {
              top: "-1px",
              width: rem(16),
              height: rem(16),
              marginLeft: rem(3),
            },
          },
        },

        "& .btn-bottom-wrap": {
          padding: `0 ${rem(30)}`,
        },

        /* Pagination */
        "& .MuiPagination-root": {
          "& .Mui-disabled": {
            color: palette.background.default,
            "& .MuiSvgIcon-root": {
              color: palette.background.default,
            },
          },
          "& .MuiPagination-ul": {
            "& .MuiPaginationItem-root": {
              "&.Mui-selected": {
                backgroundColor: palette.primary.main,
                // color: "#fff",
              },
            },
          },
          "& .MuiPaginationItem-root": {
            // color: palette.pagination.main,
          },
        },

        "& .bottom-area": {
          position: "relative",
          "& .MuiPagination-root": {
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%,-50%)",
          },
        },

        /**************************************************************************************************
        Form
        **************************************************************************************************/
        "& .bg-grey": {
          backgroundColor: "#F6F6F6",
        },
        "& .bg-white": {
          backgroundColor: "#FFF",
        },

        /**************************************************************************************************
        Form
        **************************************************************************************************/
        /* Common */
        "& .placeholder": {
          color: palette.text.disabled,
        },
        "& .value": {
          color: palette.grey[500],
        },
        "& .MuiInputBase-formControl": {
          overflow: "hidden",
          height: rem(30),
          margin: 0,
        },
        "& .label-row": {
          flexDirection: "row",
          alignItems: "center",

          "& .MuiInputLabel-formControl": {
            marginRight: rem(10),
          },
        },
        "& .MuiFormControl-root": {
          margin: 0,
          "& + .input": {
            marginLeft: rem(10),
          },
        },
        "& .MuiFormLabel-root": {
          color: "#000",
          "&.Mui-focused": {
            color: "#000",
          },
        },

        /* Input */
        "& input, .MuiInput-root": {
          height: rem(54),
          padding: `0 ${rem(20)}`,
          boxSizing: "border-box",
          fontSize: rem(14),
          color: palette.text.primary,
          border: `1px solid ${palette.grey[200]}`,
          borderRadius: rem(10),
          lineHeight: rem(54),
          "&::placeholder": {
            color: `${palette.text.disabled} !important`,
            opacity: "1 !important",
            fontSize: rem(14),
            fontFamily:
              "'NanumSquareRound', 'Malgun gothic','맑은고딕', Dotum, '돋움', arial, sans-serif",
          },
          "&:-internal-autofill-selected": {
            backgroundColor: "#fff !important",
            backgroundImage: "none !important",
          },
          "&:-webkit-autofill, :-webkit-autofill:hover, :-webkit-autofill:focus, :-webkit-autofill:active": {
            transition: "background-color 5000s ease-in-out 0s",
            // "-webkit-text-fill-color": "transparent",
          },
          "&:focus::placeholder": {
            opacity: "0 !important",
          },
        },
        "& input[type='search']::-webkit-search-cancel-button": {
          "-webkit-appearance": "none",
          position: "relative",
          right: rem(-4),
          height: rem(24),
          width: rem(24),
          backgroundImage: `url(${
            process.env.PUBLIC_URL
          }/images/icon/clear.svg)`,
          cursor: "pointer",
        },

        /* Text Field */
        "& .MuiInputBase-root": {
          height: rem(54),
          padding: `0 ${rem(20)}`,
          boxSizing: "border-box",
          fontSize: rem(14),
          color: palette.text.primary,
          borderColor: palette.grey[100],
          borderRadius: rem(10),
          lineHeight: rem(54),
          backgroundColor: "#fff",
          animation: "none",
          fontFamily:
            "'NanumSquareRound', 'Malgun gothic','맑은고딕', Dotum, '돋움', arial, sans-serif",
          "&:before": {
            borderBottom: "none",
          },
          "&.Mui-disabled": {
            backgroundColor: palette.background.default,
          },
          "& .MuiInputBase-input": {
            animation: "none",
            fontFamily:
              "'Malgun gothic','맑은고딕', Dotum, '돋움', arial, sans-serif",
            "&::placeholder": {
              color: `${palette.text.disabled} !important`,
              opacity: "1 !important",
              fontSize: rem(14),
              fontFamily:
                "'NanumSquareRound', 'Malgun gothic','맑은고딕', Dotum, '돋움', arial, sans-serif",
            },
          },
          "& .MuiInputBase-input.Mui-disabled": {
            "-webkit-text-fill-color": palette.text.disabled,
          },
          "& .MuiSelect-icon": {
            right: rem(13),
            width: rem(28),
            height: rem(28),
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/icon/dropdown.svg)`,
            color: "transparent",
          },
          "& .MuiIconButton-root": {
            marginRight: rem(0),
          },
        },
        "& .MuiInputLabel-root": {
          color: palette.text.primary,
          fontWeight: 700,
          fontSize: rem(14),
          "& + .MuiInputBase-root": {
            marginTop: rem(6),
          },
          "& + .MuiGrid-container": {
            marginTop: rem(-4),
          },
        },
        "& .MuiInputLabel-formControl": {
          position: "relative",
          transform: "none",
          "&.Mui-focused": {
            color: palette.text.primary,
          },
        },
        "& .Mui-required": {
          position: "relative",
          paddingLeft: rem(10),
          "& .MuiInputLabel-asterisk": {
            position: "absolute",
            top: 0,
            left: 0,
            color: palette.primary.main,
          },
        },
        "& .input.MuiInput-root": {
          border: `1px solid ${palette.grey[200]}`,
          borderRadius: "3px",
          "&:before": {
            borderBottom: "none",
          },
          "& + .input": {
            marginLeft: rem(10),
          },
        },
        "& .textarea": {
          "& .MuiInputBase-fullWidth": {
            border: `1px solid ${palette.grey[200]}`,
            height: rem(140),
            "&:before": {
              borderBottom: "none",
            },
          },
        },

        "& .MuiOutlinedInput-input": {
          // paddingLeft: "0",
          // paddingRight: "0",
          padding: 0,
          height: "100%",
          // "&:-webkit-autofill, :-webkit-autofill:hover, :-webkit-autofill:focus, :-webkit-autofill:active": {
          //   transition: "background-color 5000s ease-in-out 0s",
          //   "-webkit-text-fill-color": "transparent",
          // },
        },
        "& .MuiOutlinedInput-notchedOutline": {
          top: 0,
          borderColor: `${palette.grey[200]}`,

          "& legend": {
            height: 0,
            width: 0,
          },
        },
        "& .Mui-focused": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: "1px !important",
            borderColor: `${palette.common.black} !important`,
          },
          "& input:read-only + .MuiOutlinedInput-notchedOutline": {
            borderColor: `${palette.grey[200]} !important`,
          },
        },
        "& .MuiInputAdornment-root": {
          height: "auto",
          marginLeft: rem(5),
          marginRight: rem(-5),
          "& .MuiButton-text": {
            padding: rem(5),
            minWidth: "auto",
          },
          "& .count": {
            display: "inline-block",
            marginRight: rem(5),
            fontSize: rem(12),
            lineHeight: rem(16),
          },
        },
        "& .MuiFormHelperText-root": {
          marginLeft: 0,
          marginRight: 0,
          fontSize: rem(13),
          "&.error": {
            color: palette.primary.main,
          },
        },

        "& .form-table": {
          width: "100%",
          "& tr": {
            "& +tr": {
              marginTop: "10px",
            },
            display: "flex",
            "& th": {
              display: "flex",
              width: "auto",
              flex: "1 0 150px",
              // "& .MuiFormLabel-root": {
              //   "margin-top": "10px",
              // },
              // "align-items": "center",
            },
            "& td": {
              flex: "1 1 100%",
              width: "100%",
              "& +th": {
                "margin-left": "50px",
              },
            },
          },
          // "& +Button": {
          //   "margin-top": "10px",
          // },
        },

        /* select box */
        "& .MuiSelect-nativeInput": {
          "&:hover": {
            border: "none",
          },
        },
        "& .MuiMenu-paper": {
          width: "100%",
          "transition-duration": "0s !important",
          "& .MuiMenu-list": {
            "& .MuiMenuItem-root": {
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
          },
        },

        /* checkbox & radio */
        "& .radio-icon": {
          display: "block",
          width: "24px",
          height: "24px",
          border: `solid 1px ${palette.grey[300]}`,
          borderRadius: "50%",
        },

        "& .radio-icon-checked": {
          position: "relative",
          display: "block",
          width: "24px",
          height: "24px",
          border: `solid 1px ${palette.primary.main}`,
          borderRadius: "50%",
          backgroundColor: palette.primary.main,
          "&:before": {
            content: '""',
            display: "block",
            width: "10px",
            height: "10px",
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%,-50%)",
            backgroundColor: palette.common.white,
            borderRadius: "50%",
          },
        },
        "& .checkbox-icon": {
          display: "block",
          width: "24px",
          height: "24px",
          border: `solid 1px ${palette.grey[500]}`,
          borderRadius: rem(4),
          backgroundColor: "#fff",
        },
        "& .checkbox-icon-checked": {
          position: "relative",
          display: "block",
          width: "24px",
          height: "24px",
          border: `solid 1px ${palette.primary.main}`,
          borderRadius: rem(4),
          backgroundColor: palette.primary.main,
          "&:before": {
            content: '""',
            display: "block",
            width: "14px",
            height: "10px",
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%,-50%)",
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/icon/icon-check.svg)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% auto",
          },
        },

        "& .Mui-checked": {
          "& svg": {
            color: palette.primary.main,
          },
        },
        "& .MuiCheckbox-colorPrimary": {
          "& svg": {
            color: palette.common.white,
          },
        },

        "& .MuiFormControlLabel-root": {
          minHeight: rem(20),
          marginLeft: 0,
          marginRight: 0,

          "& .MuiButtonBase-root": {
            // padding: `0 ${rem(9)} 0 0`,
            margin: `0 ${rem(9)} 0 0`,
          },
          "& .MuiFormControlLabel-label.Mui-disabled": {
            color: palette.text.primary,
          },

          "& span": {
            "& .sub": {
              fontSize: rem(14),
              color: palette.text.disabled,
            },
            "& .line": {
              position: "relative",
              paddingLeft: rem(10),
              marginLeft: rem(5),
              "&:before": {
                content: "''",
                position: "absolute",
                top: "50%",
                left: 0,
                transform: "translateY(-50%)",
                height: "70%",
                width: "1px",
                backgroundColor: palette.info.light,
              },
            },
          },

          "& .Mui-disabled:not(.noborder)": {
            "& .radio-icon": {
              backgroundColor: palette.grey[100],
            },
            "& .radio-icon-checked": {
              position: "relative",
              backgroundColor: palette.grey[500],
              borderColor: palette.grey[500],
              "&:before": {
                content: '""',
                display: "block",
                width: "8px",
                height: "8px",
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%,-50%)",
                backgroundColor: palette.background.paper,
                borderRadius: "50%",
              },
            },
            "& .checkbox-icon": {
              backgroundColor: palette.grey[100],
            },
            "& .checkbox-icon-checked": {
              backgroundColor: palette.grey[500],
              borderColor: palette.grey[500],
              position: "relative",
              "&:before": {
                content: '""',
                display: "block",
                width: "12px",
                height: "8.5px",
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%,-50%)",
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/icon-check.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% auto",
              },
            },
            "& .Mui-disabled": {
              color: palette.background.default,
            },
          },
          "& + .MuiFormControlLabel-root": {
            marginTop: rem(26),
          },
          "&.align-start": {
            "& .MuiCheckbox-root": {
              top: rem(3),
            },
          },
        },

        "& .MuiCheckbox-root": {
          padding: 0,
          "& + .MuiCheckbox-root": {
            marginLeft: rem(10),
          },
          "&.underline": {
            "& + .MuiFormControlLabel-label": {
              borderBottom: `1px solid ${palette.text.primary}`,
              lineHeight: "1.1",
            },
          },
          "&.noborder": {
            paddingRight: `${rem(4)} !important`,
            "& .checkbox-icon": {
              width: rem(22),
              height: rem(22),
              borderColor: "transparent",
              backgroundImage: `url(${
                process.env.PUBLIC_URL
              }/images/icon/icon_check_noborder_off.svg)`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundColor: "transparent",
            },
            "& .checkbox-icon-checked": {
              width: rem(22),
              height: rem(22),
              borderColor: "transparent",
              backgroundImage: `url(${
                process.env.PUBLIC_URL
              }/images/icon/icon_check_noborder_on.svg)`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundColor: "transparent",
              "&:before": {
                display: "none",
              },
            },
            "& + .MuiTypography-root": {
              position: "relative",
              top: "1px",
            },
          },
        },
        "& .MuiRadio-root": {
          padding: 0,
          "& + .MuiRadio-root": {
            marginLeft: rem(10),
          },
        },

        "& .MuiFormGroup-row": {
          "& .MuiFormControlLabel-root": {
            marginTop: "0 !important",
            "&:not(:last-of-type)": {
              "margin-right": "30px",
            },
          },
        },
        "& .MuiSelect-iconOpen": {
          color: "#fff",
        },

        /* datepicker */
        "& .DatePicker__input": {
          border: `1px solid ${palette.grey[200]}`,
          borderRadius: "3px",
          height: rem(30),
          padding: `0 ${rem(10)}`,
          boxSizing: "border-box",
          fontSize: rem(12),
          borderColor: palette.grey[200],
          lineHeight: rem(30),
          textAlign: "left",
          "&:before": {
            borderBottom: "none",
          },
        },

        /* file */
        "& .form-file": {
          display: "block",
          position: "relative",
          paddingRight: rem(105),
          "& .MuiOutlinedInput-root": {
            "& input": {
              display: "none",
            },
          },
          "& .MuiButton-root": {
            position: "absolute",
            top: 0,
            right: 0,
            width: rem(100),
          },
          "& .nm": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            paddingLeft: rem(20),
            paddingRight: rem(20),
            color: palette.text.primary,
          },
        },

        /* textarea */
        "& .MuiTextField-root": {
          "& .MuiInputLabel-root.Mui-disabled": {
            color: palette.text.primary,
          },
        },
        "& .MuiInputBase-multiline": {
          height: "auto",
          flexDirection: "column-reverse",
          padding: `${rem(15)} ${rem(20)}`,

          "& .MuiInput-input": {
            lineHeight: "1.5",
          },
          "& .MuiInputAdornment-root": {
            width: "100%",
            justifyContent: "end",
            "-webkit-justify-content": "end",
          },

          "&.MuiInput-root": {
            "&:after": {
              display: "none",
            },
            "&:before": {
              borderBottom: "none !important",
            },
          },
        },

        /* form-grid */
        "& .form-grid": {
          "& + .form-grid": {
            marginTop: rem(15),
          },
          "& .MuiGrid-item": {
            paddingTop: 0,
          },
        },
        "& .form-label-row": {
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          "& .MuiInputLabel-root": {
            width: rem(155),
          },
          "& .cont": {
            flex: 1,
          },
          "& + .form-label-row": {
            marginTop: "10px",
          },
        },

        ["@media (max-width:768px)"]: {
          "& .MuiFormControl-root, .MuiInput-root, .MuiInputBase-root": {
            width: "100%",
          },
        },
        ["@media (hover: none)"]: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: `${palette.grey[200]} !important`,
          },
        },

        /**************************************************************************************************
        Table
        **************************************************************************************************/
        "& .MuiTableContainer-root": {
          "& .MuiTableHead-root": {
            // backgroundColor: theme.palette.background.tableHead,
          },
          "& .MuiTableCell-root": {
            padding: "6px",
          },
        },
        "& .tbl-row": {
          borderTop: `1px solid ${palette.grey[200]}`,
          borderBottom: `1px solid ${palette.grey[200]}`,
          "& tr:not(:first-of-type) th, td": {
            borderTop: `1px solid ${palette.grey[200]}`,
          },
          "& th, td": {
            padding: `${rem(16)} ${rem(15)}`,
          },
          "& tbody th": {
            backgroundColor: palette.background.default,
            textAlign: "left",
            fontWeight: 400,
          },
        },

        /**************************************************************************************************
        scroll style
        **************************************************************************************************/
        "& .scroll": {
          "&::-webkit-scrollbar": {
            width: "16px",
          },
          "&::-webkit-scrollbar-thumb": {
            border: "solid 5px transparent",
            margin: "50px 0",
            "box-shadow": "inset 0 0 10px 10px rgb(0 0 0 / 10%)",
            "border-radius": "9999px",
          },
        },

        /**************************************************************************************************
        Tabs
        **************************************************************************************************/
        "& .MuiTabs-root": {
          minHeight: "auto",
          "& .MuiButtonBase-root": {
            color: palette.grey[300],
            fontSize: rem(15),
            letterSpacing: "-0.5px",
            minHeight: "auto",
            padding: `${rem(25)} 0 ${rem(14)}`,
          },
          "& .Mui-selected": {
            color: palette.primary.main,
            fontWeight: "800",
          },
          "&.sticky": {
            position: "sticky",
            top: rem(52),
            backgroundColor: palette.background.main,
            zIndex: 1,
          },
        },
        "& .MuiTabs-scroller": {
          padding: `0 ${rem(15)}`,
          borderBottom: "1px solid",
          borderBottomColor: palette.grey[100],
          backgroundColor: palette.common.white,
          "& .MuiButtonBase-root": {
            minWidth: "auto",
            padding: 0,
            margin: `0 ${rem(15)}`,
            fontWeight: "bold",
          },
          "& .MuiTabs-indicator": {
            borderRadius: rem(30),
            // backgroundColor: palette.text.primary,
          },
        },
        "& .tabpanel": {
          height: "100%",
          "& .layout-flex": {
            height: `calc(100vh - 111px) !important`,
          },
        },

        /**************************************************************************************************
        Drawer
        **************************************************************************************************/
        "& .MuiDrawer-paper": {
          color: palette.text.primary,
        },
        "& .push-popup": {
          "& .MuiDrawer-paper": {
            minHeight: "auto !important",
          },
        },
        "& .drawer-common-bottom": {
          "& .MuiDrawer-paper": {
            borderTopLeftRadius: rem(30),
            borderTopRightRadius: rem(30),
            display: "flex",
            flexDirection: "column",
          },
          "& .btn-close": {
            position: "absolute",
            top: rem(22),
            right: rem(25),
            width: rem(24),
            height: rem(24),
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/icon/close.svg)`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          },
          "& .btn-push-off": {
            position: "absolute",
            top: rem(22),
            right: rem(25),
            width: rem(26),
            height: rem(26),
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/icon/push_off.svg)`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          },
          "& .btn-push-on": {
            position: "absolute",
            top: rem(22),
            right: rem(25),
            width: rem(26),
            height: rem(26),
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/icon/push_on.svg)`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          },
          "& .btn-wrap": {
            backgroundColor: "transparent",
          },
          "& .drawer-head": {
            position: "relative",
            padding: `${rem(25)} ${rem(30)}`,
            borderBottom: `1px solid ${palette.info.light}`,

            "& h3": {
              fontSize: rem(16),
            },
          },
          "& .drawer-body": {
            flex: 1,
            overflowY: "auto",
            "& .drawer-txt": {
              fontSize: rem(18),
              lineHeight: rem(24),
              fontWeight: 700,
            },
            "& .swiper-slide": {
              "& img": {
                display: "block",
                margin: "0 auto",
              },
            },
            "& .receipt-barcode": {
              paddingTop: rem(20),
              textAlign: "center",
              "& svg": {
                fontSize: rem(12),
              },
            },
          },
          "& .drawer-foot": {
            marginTop: "auto",
            height: rem(80),
            "& .MuiButton-contained": {
              width: "100%",
              height: "100%",
              //paddingTop: rem(27),
              //paddingBottom: rem(35),
              boxShadow: "none",
              borderRadius: "0",
              fontSize: rem(18),
              fontWeight: 700,
            },
          },

          "&.size-high .MuiDrawer-paper": {
            height: "calc(100vh - 52px)",
          },
          "&.size-top .MuiDrawer-paper": {
            height: "calc(100vh - 52px)",
          },
          "&.size-small .MuiDrawer-paper": {
            minHeight: rem(310),
            maxHeight: "calc(100vh - 52px)",
            "& .drawer-body": {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              "&.pw-flex": {
                alignItems: "start",
                "& .box-type-1": {
                  padding: `${rem(45)} ${rem(30)} ${rem(35)} ${rem(30)}`,
                },
              },
              "& .mgR15": {
                margin: `${rem(0)} ${rem(15)} ${rem(0)} ${rem(0)}`,
              },
            },
            "& .box-type-1, .box-type-10 ": {
              flex: "1",
              "& .text": {
                fontSize: rem(18),
              },
              "& .count": {
                display: "inline-block",
                fontSize: rem(14),
                lineHeight: rem(22),
                color: palette.info.main,
                lineHeight: rem(22),
                marginTop: rem(10),
              },
              "& .btm": {
                marginTop: rem(14),
              },
              "& .sub": {
                display: "inline-block",
                fontSize: rem(14),
                color: palette.info.main,
              },

              "& .illust + .text": {
                marginTop: rem(29),
              },
            },
            "& .push-box": {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flex: "1",
              "& .illust": {
                marginTop: rem(45),
              },
              "& .text": {
                marginTop: rem(37),
                fontSize: rem(18),
              },
              "& .count": {
                display: "inline-block",
                fontSize: rem(14),
                lineHeight: rem(22),
                color: palette.info.main,
                lineHeight: rem(22),
                marginTop: rem(10),
              },
              "& .link": {
                fontSize: rem(14),
                fontWeight: 400,
                margin: `${rem(30)} 0 ${rem(40)} 0`,
                textDecoration: "underline",
                textUnderlinePosition: "under",
              },
              "& .btm": {
                marginTop: rem(14),
              },
              "& .sub": {
                display: "inline-block",
                fontSize: rem(14),
                color: palette.info.main,
              },

              "& .illust + .text": {
                marginTop: rem(29),
              },
            },
          },
          "&.size-full .MuiDrawer-paper": {
            height: "100vh",
          },
          "&.hg-auto .MuiDrawer-paper": {
            minHeight: "auto",
          },
          "&.title-center": {
            "& .drawer-head h3": {
              textAlign: "center",
              fontSize: rem(18),
              fontWeight: 800,
            },
          },
        },

        //fav drawer

        "& .fav-drawer": {
          "& .drawer-head": {
            "& .MuiChip-root": {
              marginLeft: rem(6),
              padding: `${rem(2)} ${rem(6)}`,
              height: rem(18),
              lineHeight: rem(18),
              "&.disableChip": {
                background: "#bebebe",
              },
              "&.blackChip": {
                background: "#000",
              },
              "& .MuiChip-label": {
                fontWeight: 400,
              },
            },
          },

          "& .drawer-body": {
            display: "flex",
            alignItems: "flex-start !important",
            flexDirection: "column",
            "& .info-table": {
              // margin: `0 0 0 ${rem(28)}`,
              margin: `${rem(30)} ${rem(30)} ${rem(30)} ${rem(58)}`,
              textAlign: "left",
              "& tr": {
                display: "flex",
                flexDirection: "row",
                lineHeight: rem(30),
                "& + tr": { marginTop: rem(20) },
                "& th": {
                  minWidth: rem(71),
                  fontWeight: 700,
                  fontSize: rem(14),
                  lineHeight: rem(22),
                },
                "& td": {
                  fontSize: rem(14),
                  lineHeight: rem(22),
                  // paddingTop: rem(10),
                  wordBreak: "break-word",
                  "& .info-txt": {
                    // paddingLeft: rem(8),
                    fontSize: rem(13),
                  },
                },
              },
              "& .time": {
                position: "relative",
                "&::after": {
                  content: "''",
                  position: "absolute",
                  top: rem(0),
                  left: rem(-28),
                  width: rem(22),
                  height: rem(22),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/clock-black.svg)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                },
              },
              "& .calendar": {
                position: "relative",
                "&::after": {
                  content: "''",
                  position: "absolute",
                  top: rem(0),
                  left: rem(-28),
                  width: rem(22),
                  height: rem(22),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/calendar.svg)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                },
              },
              "& .location": {
                position: "relative",
                "&::after": {
                  content: "''",
                  position: "absolute",
                  top: rem(0),
                  left: rem(-28),
                  width: rem(22),
                  height: rem(22),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/location.svg)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                },
              },
              "& .call": {
                position: "relative",
                "&::after": {
                  content: "''",
                  position: "absolute",
                  top: rem(0),
                  left: rem(-28),
                  width: rem(22),
                  height: rem(22),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/call.svg)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                },
              },
            },
            "& button": {
              margin: `${rem(10)} auto ${rem(40)} auto`,
            },
          },
        },

        /**************************************************************************************************
        Alert
        **************************************************************************************************/
        "& .alert-wrap": {
          "& .MuiPaper-root": {
            width: "100%",
            borderRadius: rem(30),
            margin: rem(40),
          },
          "& .tit-center": {
            fontSize: rem(18),
            fontWeight: 700,
            textAlign: "center",
            padding: `${rem(30)} 0 0 0`,
          },
          "& .MuiDialogContent-root": {
            padding: `${rem(30)} ${rem(40)}`,
            lineHeight: rem(22),
            "& .MuiDialogContentText-root": {
              textAlign: "center",
              color: palette.common.black,
              fontSize: rem(15),
            },
          },
          "& .MuiDialogActions-root": {
            padding: 0,
            "&.btn-center": {
              justifyContent: "center",
              height: rem(55),
              "& .MuiButton-root": {
                "& + .MuiButton-root": {
                  marginLeft: 0,
                  "&:hover, &:active, &:focus": {
                    backgroundColor: palette.primary.main,
                  },
                },
              },
              "& .MuiButton-contained": {
                width: "100%",
                height: "100%",
                boxShadow: "none",
                borderRadius: "0",
                fontSize: rem(16),
                fontWeight: 700,
                "& .btn-cancel": {
                  backgroundColor: "#bebebe",
                },
              },
            },
          },
        },

        /**************************************************************************************************
        Dialog
        **************************************************************************************************/
        "& .MuiDialog-container": {
          "& .MuiAppBar-root": {
            backgroundColor: "#fff",
            boxShadow: "none",
            color: palette.text.primary,
            "& .MuiToolbar-root": {
              justifyContent: "center",
              minHeight: rem(52),
              "& .btn-close": {
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
                right: rem(25),
                width: rem(24),
                height: rem(24),
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/close.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              },
            },
          },
          "& .MuiDialog-paperFullScreen": {
            "& .MuiDialogContent-root": {
              padding: `${rem(52)} 0 0`,
            },
          },
        },

        /****************************************************
        Toast
        ****************************************************/
        "& .toast": {
          backgroundColor: `rgba(0,0,0,0.4)`,
          borderRadius: rem(10),
          color: "#fff",
          textAlign: "center",
          fontSize: rem(14),
          "& .MuiAlert-message": {
            flex: 1,
          },
          "&.fixed": {
            position: "fixed",
            bottom: rem(20),
            left: "50%",
            transform: "translateX(-50%)",
            width: "80%",
            "&.move-up": {
              bottom: "40vh",
            },
          },
        },

        /****************************************************
        Chip
        ****************************************************/
        "& .MuiChip-root": {
          "&.MuiChip-filledDefault": {
            backgroundColor: "rgba(0,0,0, 0.4)",
            color: "#fff",
          },
          "&.MuiChip-sizeMedium": {
            height: rem(20),
            padding: `${rem(3)} ${rem(10)} 0`,
            fontSize: rem(12),
          },
          "&.MuiChip-sizeSmall": {
            height: rem(16),
            padding: `0 ${rem(8)}`,
            fontSize: rem(10),
          },
          "& .MuiChip-label": {
            padding: 0,
          },
          "&	.MuiChip-colorSecondary": {
            backgroundColor: palette.common.black,
          },
        },

        /****************************************************
        Switch
        ****************************************************/
        "& .MuiSwitch-root": {
          width: rem(50),
          height: rem(30),
          padding: 0,
          alignItems: "center",
          justifyContent: "center",
          "& .MuiSwitch-track": {
            backgroundColor: "#fff",
            border: "1px solid #eee",
            borderRadius: rem(20),
            boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.13)",
            borderRadius: rem(22),
          },
          "& .MuiSwitch-switchBase": {
            padding: 0,
            "& .MuiSwitch-thumb": {
              background: palette.common.white,
              width: rem(26),
              height: rem(26),
              margin: rem(2),
              boxShadow: "0 1px 4px rgba(134, 134, 134, 0.4)",
            },
            "&.Mui-checked": {
              "& + .MuiSwitch-track": {
                backgroundColor: palette.primary.main,
                opacity: 1,
                borderRadius: rem(22),
                borderColor: palette.primary.main,
              },
            },
          },
        },
        /****************************************************
        Swiper
        ****************************************************/
        "& .mySwiper": {
          paddingBottom: rem(25),
          "& .swiper-pagination": {
            bottom: 0,
            "&.swiper-pagination-bullets": {
              "& .swiper-pagination-bullet": {
                margin: `0 ${rem(3)}`,
                width: rem(6),
                height: rem(6),
                "&.swiper-pagination-bullet-active": {
                  width: rem(14),
                  backgroundColor: `rgba(0,0,0,0.6)`,
                  borderRadius: rem(3),
                },
              },
            },
          },
          "& .swiper-button-prev": {
            color: "#000000",
            left: "20px",
            "&:after": {
              fontSize: rem(30),
              fontWeight: 800,
            },
          },
          "& .swiper-button-next": {
            color: "#000000",
            right: "20px",
            "&:after": {
              fontSize: rem(30),
              fontWeight: 800,
            },
          },
          "& .swiper-button-disabled": {
            display: "none",
          },
        },
        "& .popup-swiper": {
          width: "100vw !important",
          "& .swiper-slide": {
            width: "100vw !important",
            "& img": { width: "100vw !important" },
          },
        },
        "& .swiper-pagination-fraction": {
          position: "absolute",
          minWidth: rem(34),
          fontWeight: 700,
          fontSize: rem(9),
          lineHeight: rem(12),
          top: rem(30),
          right: rem(30),
          zIndex: 2,
          backgroundColor: "#0000001A",
          borderRadius: rem(8),
          padding: `${rem(2)} ${rem(8)} ${rem(1)}`,
          bottom: "auto",
          left: "auto",
          width: "auto",
        },
      },
      ["@media (max-width:768px)"]: {
        ".bottom-area": {
          "& .MuiGrid-root:only-child": {
            "& .MuiGrid-item": {
              // width: "95%",
              flex: 1,
              "& .MuiButton-root": {
                width: "100%",
              },
            },
          },
        },
      },
    },
  })(() => null);

  return <GlobalCss />;
}
export default Global;
